module.exports = __webpack_public_path__ + "img/telefonia_ip.16d58040.png";